import {errorsCodes} from 'common/errors';
import {toast} from 'react-toastify';


export const utils = {
  getErrorString: (error) => {
    let textError = '';
    const arr = Object.values(error.response.data).flat();
    for (let i = 0; i < arr.length; i += 1) {
      textError += `${arr[i]}\n`;
    }
    return textError;
  },
  showErrorToast: (error) => {
    if (error.response?.status === errorsCodes.SERVER_ERROR) {
      toast.error(error.response.statusText);
    }

    if (error.response?.data) {
      toast.error(utils.getErrorString(error));
    } else {
      toast.error(error.message ? error.message : error);
    }
  },
  toArrayMapping: (data) => {
    return data.reduce((dict, item) => {
      dict[item.id] = item;
      return dict;
    }, {});
  },
  toArrayWithKey: (data) => {
    return data ? Object.entries(data)?.map(([key, value]) => ({
      ...value,
      key,
    })) : [];
  },
  removeItemsFromArray: (arr, target) => {
    return arr.filter((item) => item !== target);
  },
  timeStringToSeconds: (timeString) => {
    const [hours, minutes, seconds] = timeString.split(':')?.map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  },
  secondsToTimeString: (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  },
  sortArray: (data) => {
    return data.sort((item1, item2) => item1 - item2);
  },
  ellipseText: (text, noOfChar) => {
    return text.length > noOfChar ? `${text.substring(0, 11)}...` : text;
  },
  snakeToTitleCase: (snakeStr) => {
    return snakeStr
      .split('_') // Split the string by underscores
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  },
  isObjectEmpty: (obj) => {
    return obj === null || obj === undefined || (Object.keys(obj).length === 0 && obj.constructor === Object);
  },
  hasPermission: (user, permission) => {
    if (!user || !user.sub_role || !Array.isArray(user.sub_role.permissions)) return false;
    return user.sub_role.permissions.includes(permission);
  }
};

// Format currency to display with proper currency symbol and formatting
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '$0.00';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);
};

// Format price (number) with comma separators for PKR
export const formatPrice = (amount) => {
  if (amount === null || amount === undefined || amount === '') return '0';
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(numAmount)) return '0';
  return numAmount.toLocaleString('en-US');
};

// Format date to display in a readable format
export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

// Format date and time for display
export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};
